import axios from 'axios'
import toggleLoading from '@/plugins/LoadingSpinner'
import store from '@/store'

/**
 * @instance axios 實體，方便進行 config 及攔截器的管理
 */
const request = axios.create({
  baseURL: '/backendapi',
  timeout: 30 * 1000,
})

const handleError = (error) => {
  toggleLoading(false)
  return {
    data: false,
    error: true,
    msg: error.toString() === 'AxiosError: Request failed with status code 500' ? '系統錯誤' : error.toString(),
  }
}

request.interceptors.request.use(function (config) {
  if(config.headers?.disableLoading =='true'){
    return config;
  }
  toggleLoading(true)
  return config
}, handleError)

request.interceptors.response.use(function (response) {
  if (response.data.error === 10002) {
    store.state.userInfo = {}
  }
  toggleLoading(false)
  return response.data
}, handleError)

export default request
